import React from "react";
import styles from "./Leader.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { MdOutlineArrowOutward } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const Leaders = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col md={6} sm={12}>
            <div className={styles.left_section}>
              <h6>Trusted by Industry Leaders Worldwide</h6>
              <span>
                Our clients’ success stories and trusted partnerships drive us
                to excel every day.
              </span>
              <p>
                At <strong>CrossBorder BTC,</strong> we take pride in the trust
                and confidence our clients and partners place in us. From
                startups to global enterprises, we have empowered businesses
                with reliable solutions, seamless execution, and exceptional
                outcomes.
              </p>
              <span
                onClick={() => navigate(`/contact`)}
                style={{ color: "#FF5C00", cursor: "pointer" }}
              >
                {" "}
                Partner with Us Today <MdOutlineArrowOutward />
              </span>
              <img
                loading="lazy"
                src="/images/landingPageImages/parnter.png"
                alt="partner"
              />
            </div>
          </Col>
          <Col md={6} sm={12}>
            <div className={styles.right_section}>
              <img
                loading="lazy"
                src="/images/landingPageImages/client.png"
                alt="partner"
              />
              <div className={styles.clientSection}>
                <img
                  loading="lazy"
                  src="/images/landingPageImages/icon.png"
                  alt="icon"
                />
                <p>
                  CrossBorder BTC’s expertise and professionalism have been
                  instrumental in scaling our operations globally. Their
                  commitment to quality is unparalleled.
                </p>
                <p>– [Client Name, Title, Company]</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Leaders;
